import { Record } from "immutable";
import moment from "moment";

const defaults = {
    boardId: undefined,
    users: [],
};

interface IUserPermission {
    boardId: string;
    granted_at_ms: moment.Moment;
    identity: string;
    identity_type: string;
    permission_type: string;
    email?: string;
    name?: string;
}

export class Permission extends Record(defaults) {
    declare boardId: string;
    declare users: [IUserPermission];
    constructor(args) {
        super({
            ...args,
            users: (args.users || []).map((user) => ({
                ...user,
                granted_at_ms: moment.utc(parseInt(user.granted_at_ms, 10)),
            })),
        });
    }
}
